export class BehaviorType {
  static UNDEFINED = -1;
  static SELF_INJURIOUS = 0;
  static AGGRESIVE = 1;
  static DISTURBANCE = 2;
  static NON_COMPLIANCE = 3;
  static SELF_STIMULATION = 4;
  static OTHER = 99;
}
